module.exports = __webpack_public_path__ + "img/ZW.7716e6c0.svg";